import {createFileRoute, getRouteApi} from '@tanstack/react-router';
import {MembersList} from '@/components/membersList/membersList';
import {
  getOrganizerAdmins,
  getOrganizerPublicMembers,
} from '@/server/organizerMember';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://wayra.cc';

const parentRouteApi = getRouteApi('/organizer/$organizerId');

export const Route = createFileRoute('/organizer/$organizerId/members')({
  loader: async ({params}) => {
    const [admins, membersPage] = await Promise.all([
      getOrganizerAdmins({data: {organizerId: params.organizerId}}),
      getOrganizerPublicMembers({
        data: {organizerId: params.organizerId, page: 1, pageSize: 50},
      }),
    ]);
    return {admins, membersPage};
  },
  head: ({params, loaderData}) => {
    if (!loaderData) return {};
    return {
      links: [
        {
          rel: 'canonical',
          href: `${SITE_URL}/organizer/${params.organizerId}/members`,
        },
      ],
    };
  },
  component: OrganizerMembersTab,
});

/** Members tab — loads admins + first page of members, renders MembersList. The parent layout owns the page wrapper and sidebar. */
function OrganizerMembersTab() {
  const {admins, membersPage} = Route.useLoaderData();
  const {organizer} = parentRouteApi.useLoaderData();

  return (
    <MembersList
      organizerId={organizer.id}
      admins={admins}
      initialMembers={membersPage}
    />
  );
}
